import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faArrowLeft,
    faLanguage,
    faChevronDown,
    faSpinner,
    faExclamationTriangle,
    faGlobe,
} from "@fortawesome/free-solid-svg-icons";
import "./test-instructions.css";

export default function TestInstructions() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [testData, setTestData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedLanguage, setSelectedLanguage] = useState("Hindi");

    useEffect(() => {
        const fetchTestData = async () => {
            try {
                setLoading(true);
                const response = await axios.get(
                    `https://api.employscope.com/test/${id}`,
                    {
                        headers: {
                            Authorization: localStorage.getItem("token"),
                        },
                    }
                );

                if (response.data.status) {
                    setTestData(response.data.data);
                    if (response.data.data.language) {
                        setSelectedLanguage(response.data.data.language);
                    }
                } else {
                    setError("Failed to load test data");
                }
            } catch (error) {
                console.error("Error fetching test data:", error);
                setError("Failed to load test data");
            } finally {
                setLoading(false);
            }
        };

        if (id) {
            fetchTestData();
        }
    }, [id]);

    if (loading) {
        return (
            <div className="test-instructions-loading">
                <FontAwesomeIcon icon={faSpinner} spin size="3x" />
                <p>Loading test instructions...</p>
            </div>
        );
    }

    if (error || !testData) {
        return (
            <div className="test-instructions-error">
                <FontAwesomeIcon icon={faExclamationTriangle} size="3x" />
                <h3>{error || "Test not found"}</h3>
                <button className="btn-back" onClick={() => navigate(-1)}>
                    <FontAwesomeIcon icon={faArrowLeft} /> Go Back
                </button>
            </div>
        );
    }

    return (
        <div className="test-instructions-container">

            <div className="test-info-cards">
                <div className="info-card">
                    <div className="info-label">Question</div>
                    <div className="info-value">{testData.questionCount || testData.totalQuestions || 30}</div>
                </div>

                <div className="info-card">
                    <div className="info-label">Mark</div>
                    <div className="info-value">{testData.marks || testData.totalMarks || 30}</div>
                </div>

                <div className="info-card">
                    <div className="info-label">Time</div>
                    <div className="info-value">{testData.duration || 30}</div>
                </div>

                <div className="info-card language-selector">
                    <FontAwesomeIcon icon={faGlobe} className="language-icon" />
                    <select
                        value={selectedLanguage}
                        onChange={(e) => setSelectedLanguage(e.target.value)}
                        className="language-dropdown"
                    >
                        <option value="English">English</option>
                        <option value="Hindi">Hindi</option>
                        <option value="Bengali">Bengali</option>
                    </select>
                    <FontAwesomeIcon icon={faChevronDown} className="dropdown-icon" />
                </div>
            </div>

            <div className="test-content">
                {testData.description && (
                    <div
                        className="description-content"
                        dangerouslySetInnerHTML={{ __html: testData.description }}
                    />
                )}
            </div>
            <style>
                {`
          .description-content h5{
            font-size: 12px;
          }
        `}
            </style>
        </div>
    );
}
